import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPopupSecondTrialComponent extends PopupInnerModalComponent<PopupData.Billing.SecondTrial> {
	@service('account') declare accountService: Service.Account;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	get canBookACall(): boolean {
		return !this.currentUserService.isClientUserInPaidClientSpace;
	}

	@action
	startChat(): void {
		this.currentUserService.chatWithSupport();
	}
	<template>
		<div class="content">

			<div class="img-ct">
				<img src="https://cdn1.databox.com/mailing/v4.0/second-trial.png" alt />
			</div>

			{{#if this.popupData.hasSecondTrialStarted}}

				<h3>Your second <strong>14-day</strong> trial has been unlocked!</h3>

				<p>
					The new 14-day trial period for your account has been
					<br /><strong>successfully activated</strong>.
				</p>

				<p>
					If there is something you were unable to evaluate or setup
					<br />in your previous trial, let us know and we’ll help...
				</p>

			{{else}}

				<h3>Your second <strong>14-day</strong> has already been unlocked!</h3>

				<p>
					The new 14-day trial period for your account
					<br /><strong>has already been activated</strong>.
				</p>

				<p>
					If you want our help evaluating and setting up Databox
					<br />for your needs, just ask...
				</p>

			{{/if}}

			{{#if this.canBookACall}}
				<div class="controls2 controls2--center">
					<a class="button" href={{this.accountService.bookACallLink}} target="_blank">
						Book a call
					</a>

					<div>or</div>

					<a role="button" class="link link--secondary" {{on "click" this.startChat}}>
						Start a chat
					</a>
				</div>
			{{/if}}
		</div>
	</template>
}
